import { z } from "zod";

export const taskTemplateSchema = z.object({
    idUUID: z.string(),
    metaCreatedWhen: z.coerce.date(),
    name: z.string(),
    displayName: z.string(),
    description: z.string(),
    duration: z
        .string()
        .min(1, { message: "Field is required" })
        .refine((val) => !Number.isNaN(Number(val)), { message: "Must be a valid number" })
        .refine((val) => Number(val) >= 0, { message: "Must be at least 0" })
        .refine((val) => Number(val) <= 100, { message: "Must be at most 100" }),
    durationUnit: z.string(),
    coreRoles: z.array(z.string()),
    caseStatuses: z.array(z.string()),
    defaultNoteTag: z.string().nullable(),
});

export const addTaskTemplateSchema = z.object({
    name: z.string().nonempty({ message: "Field is required" }),
    description: z.string().optional(),
    duration: z
        .string()
        .min(1, { message: "Field is required" })
        .refine((val) => !Number.isNaN(Number(val)), { message: "Must be a valid number" })
        .refine((val) => Number(val) >= 0, { message: "Must be at least 0" })
        .refine((val) => Number(val) <= 100, { message: "Must be at most 100" }),
    durationUnit: z.string().nonempty({ message: "Field is required" }),
    coreRoles: z.array(z.string()).nonempty({ message: "Select at least one Core Role" }),
    caseStatuses: z.array(z.string()).nonempty({ message: "Select at least one Case Status" }),
    defaultNoteTag: z.string(),
});
